import { Form, useForm, useFormContext } from 'react-hook-form';
import { PurchaseTicketGroupHeader } from 'src/modals/PurchaseWizard/PurchaseTicketsFlowV2/PurchaseTicketGroupHeader';
import { PurchaseTicketTable } from 'src/tables/PurchaseTicketTable/PurchaseTicketTable';
import {
  PurchaseOrderDetailsInput,
  TicketGroupInput,
} from 'src/WebApiController';

import { PurchaseOrderFormDataType } from '../MultiplePurchaseWizard';

const ReviewPurchaseTicketTable = ({
  index,
  disabled,
  purchaseOrder,
}: {
  index: number;
  disabled: boolean;
  purchaseOrder: PurchaseOrderDetailsInput;
}) => {
  const methods = useForm<PurchaseOrderDetailsInput>({
    defaultValues: purchaseOrder,
  });

  return (
    <Form {...methods}>
      <PurchaseTicketTable
        key={index}
        disabled={disabled}
        currencyCode={purchaseOrder?.currencyCode?.value || 'USD'}
        ticketGroups={purchaseOrder.ticketGroups}
        tgTableDisplayOnly={true}
      />
    </Form>
  );
};
export function ReviewPurchases({ disabled }: any) {
  const { control, getValues } = useFormContext<PurchaseOrderFormDataType>();
  const purchaseOrders = getValues('purchaseOrders');
  const ticketGroups = purchaseOrders[0]?.ticketGroups || [];
  const allTicketGroups: TicketGroupInput[] = [];
  purchaseOrders.forEach((purchaseOrder: PurchaseOrderDetailsInput) => {
    allTicketGroups.push(...(purchaseOrder.ticketGroups || []));
  });

  return (
    <>
      <PurchaseTicketGroupHeader
        ticketGroups={ticketGroups}
        isSingleInputModeForMultiEvent={false}
        currentGroupIndex={0}
        groupsOfTicketGroup={[ticketGroups]}
      />
      {purchaseOrders.map((purchaseOrder, index) => {
        return (
          <ReviewPurchaseTicketTable
            key={index}
            disabled={disabled}
            purchaseOrder={purchaseOrder}
            index={index}
          />
        );
      })}
    </>
  );
}
